import { CURRENCY, FieldQueryStringUrl, MONEY_MILLIONS, MONEY_THOUSAND, MoneyThousand, ThemeColor, ThemeId, } from '~/enum';
export function log(...args) {
    if (process.env.NODE_ENV === 'development') {
        console.log('[CommonGameUI]', ...args);
    }
}
export const convertDataTexture = (data, ratio = 2) => {
    var _a, _b;
    let dataTexture = {};
    for (const spriteName in data) {
        const sprite = data[spriteName].frame;
        const fileName = (_b = (_a = data[spriteName]) === null || _a === void 0 ? void 0 : _a.filename) === null || _b === void 0 ? void 0 : _b.replace('.png', '');
        switch (fileName) {
            default: {
                dataTexture = Object.assign(Object.assign({}, dataTexture), { [fileName]: {
                        sx: sprite.x,
                        sy: sprite.y,
                        sWidth: sprite.w,
                        sHeight: sprite.h,
                        dx: sprite.w / ratio,
                        dy: sprite.h / ratio,
                        dWidth: sprite.w / ratio,
                        dHeight: sprite.h / ratio,
                    } });
                break;
            }
        }
    }
    return dataTexture;
};
export const convertDataLogoClbTexture = (data) => {
    var _a, _b;
    let dataTexture = {};
    for (const spriteName in data) {
        const sprite = data[spriteName].frame;
        let fileName = (_b = (_a = data[spriteName]) === null || _a === void 0 ? void 0 : _a.filename) === null || _b === void 0 ? void 0 : _b.replace('.png', '');
        if (!!fileName) {
            fileName = regexStringToAlphaCharacter(fileName);
        }
        dataTexture = Object.assign(Object.assign({}, dataTexture), { [fileName]: {
                sx: sprite.x,
                sy: sprite.y,
                sWidth: sprite.w,
                sHeight: sprite.h,
                dx: sprite.w / 2,
                dy: sprite.h / 2,
                dWidth: sprite.w / 2,
                dHeight: sprite.h / 2,
            } });
    }
    return dataTexture;
};
export const hexadecimal = (color) => {
    return (percentage) => {
        const decimal = `0${Math.round(255 * (percentage / 100)).toString(16)}`.slice(-2).toUpperCase();
        return color + decimal;
    };
};
export const regexStringToAlphaCharacter = (str) => {
    return (str !== null && str !== void 0 ? str : '').toLocaleLowerCase().replace(/[^a-zA-Z0-9]/g, '');
};
export const getSpriteLogoClbWithTeamName = (object, teamName, isHome = true) => {
    const teamNameAlpha = regexStringToAlphaCharacter(teamName);
    for (const key in object) {
        if (teamNameAlpha.toLocaleLowerCase().includes(key)) {
            return object[key];
        }
    }
    return object[isHome ? 'homedefault' : 'awaydefault'];
};
export const isCheckCurrencyVND = () => {
    const currency = CURRENCY.VND;
    if (currency === CURRENCY.VND) {
        return true;
    }
    return false;
};
export const makeRoundMoneyUSD = (value) => {
    if (!value)
        return 0;
    return Math.round(value * 100) / 100;
};
export const convertNumberToInteger = (value) => {
    if (!value)
        return 0;
    return parseInt(value.toString());
};
export const numberFormat = (_number) => {
    if (null === _number || 'undefined' === typeof _number || isNaN(_number)) {
        return '0';
    }
    const absValue = isCheckCurrencyVND()
        ? convertNumberToInteger(_number)
        : makeRoundMoneyUSD(_number);
    return absValue.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
};
export const calculateTimeDifference = (start, end, diffType = 'second') => {
    if (!start || !end)
        return null;
    // Convert inputs to Date objects
    const startDate = start instanceof Date ? start : new Date(start);
    const endDate = end instanceof Date ? end : new Date(end);
    // Check if dates are valid
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        throw new Error('Invalid date format');
    }
    // Calculate difference in milliseconds
    const diffMs = endDate.getTime() - startDate.getTime();
    // Return 0 if difference is negative or zero
    if (diffMs <= 0) {
        return 0;
    }
    // Convert milliseconds to requested unit
    switch (diffType) {
        case 'second':
            return Math.floor(diffMs / 1000);
        case 'minute':
            return Math.floor(diffMs / (1000 * 60));
        case 'hour':
            return Math.floor(diffMs / (1000 * 60 * 60));
        case 'day':
            return Math.floor(diffMs / (1000 * 60 * 60 * 24));
        case 'month': {
            const yearDiff = endDate.getFullYear() - startDate.getFullYear();
            const monthDiff = endDate.getMonth() - startDate.getMonth();
            return yearDiff * 12 + monthDiff;
        }
        case 'year':
            return endDate.getFullYear() - startDate.getFullYear();
        default:
            return Math.floor(diffMs / 1000); // Default to seconds
    }
};
export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
export const getThemeColor = (themeId) => {
    const { Theme1, Theme3, Theme4, Theme5, Theme6, Theme7, Theme8, Theme9, Theme10, Theme11, Theme12, Theme13, } = ThemeId;
    switch (themeId) {
        case Theme10:
            return ThemeColor.Green;
        case Theme3:
        case Theme7:
        case Theme8:
            return ThemeColor.Gold;
        case Theme4:
        case Theme5:
        case Theme6:
        case Theme11:
            return ThemeColor.Red;
        case Theme9:
        case Theme12:
        case Theme13:
            return ThemeColor.Blue;
        case Theme1:
            return ThemeColor.LightGreen;
        default:
            return ThemeColor.Blue;
    }
};
export const convertNumberToTimeWithFormat = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) {
        // Format as HH:MM:SS if hours are present
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
    else {
        // Format as MM:SS if no hours
        if (minutes === 1 && secs === 0) {
            return '60';
        }
        if (minutes === 0) {
            return `${String(secs)}`;
        }
        return `${String(minutes)}:${String(secs).padStart(2, '0')}`;
    }
};
export const isJson = (str, allowPrimitives = false) => {
    if (typeof str !== 'string')
        return false;
    try {
        const parsed = JSON.parse(str);
        // If not allowing primitives, check if result is object or array
        if (!allowPrimitives) {
            return parsed !== null && typeof parsed === 'object';
        }
        return true;
    }
    catch (e) {
        return false;
    }
};
/**
 * Checks if the current device is a mobile device
 * @returns boolean - True if the device is mobile, false otherwise
 */
export const isMobileDevice = () => {
    // Check for touch support first (most reliable for modern devices)
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        // Additional check with user agent to filter out touch-enabled desktops
        const userAgent = navigator.userAgent.toLowerCase();
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(userAgent);
    }
    return false;
};
export const convertAmountToMoney = (amount) => {
    if (!amount) {
        return '0';
    }
    if (amount >= MoneyThousand.M) {
        return `${Math.round(amount) / MoneyThousand.M}M`;
    }
    return `${amount / MoneyThousand.K}K`;
};
export const objectToQueryString = (obj) => {
    const params = new URLSearchParams();
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            params.append(key, obj[key]);
        }
    }
    return params.toString();
};
export const paramURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const agentId = urlParams.get(FieldQueryStringUrl.agentId) || '';
    const token = urlParams.get(FieldQueryStringUrl.token) || '';
    return {
        agentId,
        token,
    };
};
export const formatNumber = (amount) => Math.round(amount * MONEY_THOUSAND) / MONEY_THOUSAND;
export const moneyFormatWithCurrency = (amount, currency) => {
    if (currency === CURRENCY.VND) {
        return Math.round(formatNumber(amount) / MONEY_THOUSAND);
    }
    return Math.round(amount);
};
export function isFloat(value) {
    return typeof value === 'number' && !Number.isInteger(value) && Number.isFinite(value);
}
export function formatPercentage(num) {
    if (!num)
        return 0;
    const hasFloat = isFloat(num);
    if (hasFloat) {
        return Math.round(num * 100) / 100;
    }
    return Math.round(num);
}
export function isEmpty(value) {
    // null or undefined
    if (value == null)
        return true;
    // array or string
    if (typeof value === 'string' || Array.isArray(value)) {
        return value.length === 0;
    }
    // object
    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }
    // everything else (number, boolean, function, etc.)
    return false;
}
export const getFormatCurrency = (currency) => {
    if (currency === CURRENCY.VND) {
        return 'K';
    }
    if (currency === CURRENCY.THB) {
        return 'THB';
    }
    return currency;
};
export const formatMoneyStringWithCurrency = (amount, currency) => {
    if (amount === 0 || isNaN(amount) || !isFinite(amount))
        return '0';
    if (currency === CURRENCY.VND) {
        if (amount.toString().length > 6) {
            return Math.floor((amount / MONEY_MILLIONS) * 10) / 10 + 'M';
        }
        return Math.round(formatNumber(amount) / MONEY_THOUSAND) + getFormatCurrency(currency);
    }
    return Math.round(amount) + getFormatCurrency(currency);
};
export const formatNumberToTime = (seconds) => {
    if (seconds <= 0)
        return '00:00';
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};
